import { render, staticRenderFns } from "./DepartmentFilter.vue?vue&type=template&id=38e01f9e&scoped=true&"
import script from "./DepartmentFilter.vue?vue&type=script&lang=ts&"
export * from "./DepartmentFilter.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentFilter.vue?vue&type=style&index=0&id=38e01f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e01f9e",
  null
  
)

export default component.exports